import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { createBrowserHistory } from 'history'
import * as serviceWorker from './serviceWorker'
import { persistor, store } from '@store'
import App from './App'
import UpdateDialog from '@components/UpdateDialog'
import { ErrorBoundary } from 'react-error-boundary'
import SomethingWentWrong from '@components/SomethingWentWrong'

const history = createBrowserHistory()
const root = createRoot(document.getElementById('root'))

root.render(
    <ErrorBoundary FallbackComponent={React.memo(SomethingWentWrong)}>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Router history={history}>
                    <Suspense fallback={null}>
                        <UpdateDialog />
                        <App />
                    </Suspense>
                </Router>
            </PersistGate>
        </Provider>
    </ErrorBoundary>
)

if (new URLSearchParams(window.location.search).has('scan')) {
    serviceWorker.unregister()
} else {
    serviceWorker.register()
}
